export default function ContractCMADual({
    isChecked,
    handleCheckboxChange,
    handleNextButtonClick,
}) {
    const contractText = `Becker CMA 中英文雙軌備考方案
購買須知與相關規定（請務必詳閱）
1. 訂購程序、審閱期與契約成立
1.1. 購買「Becker CMA 中英文雙軌備考方案」（以下稱「本方案」）者，須填妥訂購單資料表，完整審閱本購買須知與相關規定後，完成付費，方符合訂購程序。繳費前，請先確認購買產品內容、方案權益、使用規定與費用。
1.2. 購買前請確認已完整審閱本購買須知與相關規定，審閱期已達五日。
1.3. 購買方案者保證為完全行為能力人，或為已得法定代理人同意之限制行為能力人。
1.4. 購買者於本線上報名及訂購流程中勾選「同意」並完成購買程序時，即表示已完整審閱並確認同意本契約全部條款內容，並同意以系統依其所填載之中文姓名自動產生之電子簽名（屬電子形式之姓名印記，非本人親筆簽名）作為本人簽名及用印之正式意思表示。購買者確認該電子簽名係其真意表示，並同意不得以非親筆簽名或電子形式為由否認其法律效力。系統並將依該電子簽名自動生成並成立本購買契約書，其效力與經購買者親筆簽名之書面契約相同，對雙方均具法律拘束力。
1.5. 本方案正式名稱為「Becker CMA 中英文雙軌備考方案」，本方案目的在提供學員使用 Becker CMA Exam Review 原廠教材、英文 CMA 考試中文雲端課程、中文 CMA 考試中文雲端課程與相關備考輔助資料，協助學員依自身需求準備中文 CMA 或英文 CMA 考試。

2. 方案內容與服務範圍
2.1. 本方案定價為新台幣 88,000 元。
2.2. 本方案使用效期為二十四個月。Becker CMA Exam Review 軟體使用權限效期，依美國 Becker 原廠規定，自購買日起算二十四個月後終止。Becker Taiwan 中文雲端課程與本方案所含在地加值服務之使用效期，原則上與本方案效期一致，除本契約另有規定或 Becker Taiwan 另有公告外，逾期即不得再使用。
2.3. 本方案包含以下內容：
Becker CMA Exam Review 原廠軟體教材。
Becker CMA Exam Review 全英文電子書教材與英文題庫。
Becker 美國講師 lecture 影片，影片可設定中文字幕。
英文 CMA 考試中文雲端課程，共 81 小時；另將於 2026 年 10–11 月逐步新增並上架英文 CMA CBQ 解題影片，兩科共 12 個 Unit、合計約 12 小時。
中文 CMA 考試中文雲端課程，共 78 小時。
中文雲端課程觀看額度 200 小時。
CMA 考試中英繁簡用詞對照表。
中文 CMA 考試歷年題型參考資料／Sample Test。
Becker Taiwan 依本契約提供之相關學員服務。
2.4. Becker CMA Exam Review 原廠軟體教材為全英文介面、英文教材與英文題庫。購買者確認已知悉本方案所含原廠教材並非中文介面教材，亦非中文題庫。
2.5. 英文 CMA 考試中文雲端課程係針對英文 CMA 考試設計，以中文講解 Becker 原廠英文教材內容、英文 CMA 考試重點與解題邏輯。因應 CMA 考試將於 2026 年 11 月 1 日起，在台灣考場更新考題，將原本的 essay questions 改為 Case-Based Questions（CBQs），Becker CMA Exam Review 針對台灣、中國、日本地區之教材亦將於 2026 年 11 月 1 日起更新，改為提供 CBQ 練習題，供相關地區考生按照符合該地區出題題型之方式練習與備考。
2.6. 中文 CMA 考試中文雲端課程係針對中文 CMA 考試設計，目的在協助台灣考生熟悉中文 CMA 考試之題目表述、專業術語、紙筆考試形式，以及中文 CMA 考試使用之中國財會專業用語與台灣慣用財會用語間之差異。
2.7. 本方案為 CMA 備考教材與課程服務方案，並非考試報名服務、考場保證服務、證照申請保證服務或考試通過保證服務。IMA 會員費、CMA 考試報名費、考場預約費、證照申請費用、官方審查費用及其他由 IMA 或相關考試機構收取之費用，均不包含於本方案價格內。

3. 退費、七日猶豫期與數位內容提供
3.1. 本商品屬於行政院公告之「通訊交易解除權合理例外情事適用準則」第 2 條可排除消費者保護法第 19 條七日解除權之合理例外情事者。
3.2. 惟若商品未經領取、未開始參加課程、未申請或使用任何中文雲端課程觀看點數、未下載或取得本方案所含資料檔案，且未登入任何產品內含學習帳號時，購買後七日猶豫期內得要求退費；若已取得諮詢者，退費時需扣除每階段 1,000 元諮詢費。
3.3. 本人知悉並同意，本商品屬非以有形媒介提供之數位內容及／或一經提供即為完成之線上服務；一經帳號開通、登入、教材領取、課程內容提供、中文雲端課程點數提供、中文雲端課程觀看權限開通、CMA 考試中英繁簡用詞對照表提供，或中文 CMA 考試歷年題型參考資料／Sample Test 提供，即排除消保法第 19 條七日解除權之適用。
3.4. 除可歸責於 Becker Taiwan（捷進）或依法不得排除之情形外，教材一經領取、帳號開通、登入使用、中文雲端課程點數提供、課程內容提供或本方案所含資料檔案提供後，學員不得任意要求退費、轉讓、變更方案、暫停效期或延長效期。
3.5. 學員之 Becker CMA Exam Review 個人教材軟體帳號經首次登入後，教材恕不退費，亦不得要求暫停效期。
3.6. 學員一經使用或申請中文雲端課程觀看點數，或下載、取得、閱覽本方案所含之 CMA 考試中英繁簡用詞對照表、中文 CMA 考試歷年題型參考資料／Sample Test 或其他數位資料，即視為相關數位內容已提供，不得以尚未完整觀看、尚未使用完畢、尚未參加考試、未通過考試、考試日期異動、官方考場安排不符預期或個人備考規劃變更為由，要求退費、延期或補償。

4. 軟體帳號、使用權限與帳號安全
4.1. 美國管理會計師 Becker CMA Exam Review 系列教材為美國進口原版教材與軟體，限購買者個人使用，不得轉贈、轉讓、出租、出借、出售、分享或提供予第三人使用。
4.2. 美國管理會計師 Becker CMA Exam Review 使用權限效期，於軟體購買當日起算後之二十四個月後終止。（Your Becker CMA Exam Review license will expire 24 months from the date of purchase.）
4.3. 學員領取帳號後，應妥善保管其登入帳號與密碼，確保不為他人得知。利用學員帳號密碼登入學習帳號者，將推定為學員本人之行為。
4.4. 因非可歸責於 Becker Taiwan（捷進）之事由導致登入帳號或密碼外洩時，學員應儘速通知 Becker Taiwan（捷進）；Becker Taiwan（捷進）除提供必要協助外，不負任何法律上責任。
4.5. 為提升服務品質及確保學員正確使用本教材，Becker Professional Education 與 Becker Taiwan（捷進）將蒐集、處理並分析系列產品使用帳號之軟體登錄時間、網路位址（IP address）等相關資訊。在任何情況下，系統若發現有多人登錄同一帳號、異常大量登入、疑似帳號共享、疑似自動化存取、疑似側錄或其他違反本契約之使用情況，Becker Taiwan（捷進）有權暫停、中止或終止該帳號之軟體權限、中文雲端課程使用權限及本方案相關服務。
4.6. 學員不得以任何方式破解、規避、干擾、反向工程、擷取、複製、下載、側錄、重製或散布 Becker CMA Exam Review 軟體、題庫、課程影片、講義、題型參考資料、用詞對照表或其他本方案所含數位內容。

5. 教材、教科書與原廠供貨
5.1. 教材（軟體登入權限）將於購買者清款後提供。實際帳號開通時間仍須視 Becker Taiwan 作業流程、Becker 原廠系統處理、學員提供資料完整性及其他相關因素而定。
5.2. 本方案提供 Becker CMA Exam Review 電子教材與線上軟體權限，除方案頁或訂購單另有明文載明外，方案價格不包含紙本教科書。
5.3. 2025 年 1 月 1 日起，所有方案提供電子教科書，不包含紙本教科書。因個人筆記習慣須加購紙本教科書者，每本需酌收加購費用，加購價格依美國 Becker 規定之定價加上國際運費。
5.4. 若遇書籍取用完畢，需等待國際郵務寄達台灣，無法指定取書時間。
5.5. 賣方保留任何因賣方代理原廠停產、改版、系統更新、供貨調整或產品規格變更而停止供貨、更改內容、調整產品規格或更改提供方式之權利，並對此不負擔責任。但 Becker Taiwan（捷進）將於合理範圍內協助學員取得可使用之學習資源。
5.6. Becker CMA Exam Review 軟體教材、題庫、模擬考、lecture 影片及相關功能之內容、介面、題目數量、系統功能、影音設定、字幕功能、更新頻率與使用方式，均以 Becker Professional Education 原廠實際提供內容為準。Becker Taiwan（捷進）不保證原廠功能、介面或內容永不變更。

6. 聯繫信箱與通知
6.1. 學員資料表 E-mail 信箱資訊，有效期限必須達二十四個月以上。購買後請自行定期收信，本方案之軟體服務、課程通知、帳號資訊、考試資訊、課程上架資訊、點數使用資訊、加值服務資訊及一切相關通知，將以該 E-mail 信箱為主要聯繫方式。
6.2. 若因學員未提供正確 E-mail、未定期收信、信箱容量不足、信件進入垃圾信件匣、未留意 Becker Taiwan（捷進）通知，或未即時更新聯繫資料，導致權益受影響，學員應自負其責。
6.3. 學員如變更 E-mail、電話、通訊軟體帳號或其他聯繫方式，應主動通知 Becker Taiwan（捷進）更新資料。於 Becker Taiwan（捷進）完成資料更新前，依原資料發出之通知仍視為有效送達。

7. 使用設備與連線需求
7.1. 使用本服務應具備下列軟硬體設備基本規格及要求：
Windows PC/NB：Windows 7 以上。
Apple PC/NB：macOS 10 以上。
Apple 行動裝置：iOS 13.0 以上。
Android 行動裝置：Android 8.0 以上。
行動裝置限定使用 APP 版觀看課程。
連線需求：寬頻網路下載速度 20Mbps 以上。
7.2. 不建議使用無線、社區型、有線電視台網路、公共免費網路，可能造成無法正常驗證登入、觀看品質不穩、連線中斷或個人帳號密碼資料外洩。
7.3. 其餘未列示之軟硬體或系統，恕不保證其觀看學習品質。
7.4. 學員應自行備妥符合 Becker CMA Exam Review、Becker Taiwan 中文雲端教室及相關數位服務所需之設備、網路、瀏覽器、作業系統、應用程式及其他使用環境。因學員設備、網路、作業系統、瀏覽器、第三方外掛程式、防火牆、公司內部網路限制或其他非可歸責於 Becker Taiwan（捷進）之因素，導致無法使用或觀看品質不佳者，Becker Taiwan（捷進）將提供必要協助，但不負退費、展延或損害賠償責任。

8. 中文課程與在地加值服務
8.1. Becker Taiwan（捷進）各項產品說明與限制如下。各方案可能包含之中文課程、線上發問系統、用詞對照表、題型參考資料及其他在地中文加值服務，其使用有效期限與本方案效期一致，除本契約另有規定或 Becker Taiwan（捷進）另有公告外，逾期即不得使用。
8.2. 中文課程研發目的在幫助考生加速通過考試，故學員使用或參加中文課程時間點為通過考試之前。
8.3. 學員之軟體使用效期結束，或學員通過全科考試時，若未使用完畢加值服務之各類型課程時數、觀看點數、資料下載權限或其他服務權益，剩餘權益等同失效，不得異議。
8.4. 使用雲端課程時，不得針對課程內容進行任何錄音、錄影、截圖、翻拍、側錄、下載、重製、公開播放、散布或其他侵害智慧財產權之行為。
8.5. 購買「無」中文課程產品或自修方案者，不得要求索取中文加值服務或中文課程之各項研習講義、文件資料。本方案學員得依本契約規定使用本方案所含中文課程與資料，但不得要求 Becker Taiwan（捷進）提供未列入本方案內容之其他課程、資料或服務。
8.6. 本方案所含中文課程與服務，Becker Taiwan（捷進）保有課程提供時間點、雲端影片開放時間、課程上架時間、講師安排、課程內容範圍、課程單元順序、補充資料提供方式、點數使用方式及服務內容之決定權，依各期實際公告或課程影片上架公告認定，學員不得異議。
8.7. 中文雲端課程係透過第三方教學影音平台提供。若因該第三方平台之系統維護、服務中斷、連線異常、平台功能調整或其他非可歸責於 Becker Taiwan（捷進）之事由，致學員暫時無法觀看或使用課程，Becker Taiwan（捷進）將提供必要協助並協調恢復服務，惟不負因此所生之損害賠償責任。
8.8. 中文 CMA 考試中文雲端課程為本方案全新製作課程，將依 Becker Taiwan 中文雲端教室公告之課表陸續上架。學員購買本方案時，即知悉並同意部分中文 CMA 課程可能尚未完整上架，實際上架時間、課程單元範圍與提供方式，均以 Becker Taiwan 中文雲端教室公告及最新課表為準。
8.9. 若因講師時程、課程製作、平台處理、系統維護、不可抗力或其他合理事由，致中文 CMA 課程上架日期有所調整，Becker Taiwan（捷進）將於合理範圍內通知學員並持續提供課程服務。除可歸責於 Becker Taiwan（捷進）且依法不得排除之情形外，學員不得因此要求退費、賠償、展延或其他補償。
8.10. 因應英文 CMA 考試題型改制，Becker Taiwan（捷進）將於 2026 年 10–11 月逐步新增並上架英文 CMA CBQ 解題影片，供購買本方案之學員於方案效期內觀看。CBQ 解題影片預計兩科各 6 個 Unit，共 12 個 Unit，每單元約 1 小時，合計約 12 小時；講師將從各 Unit 挑選具代表性的 CBQ 題型，進行解題示範與作答策略說明。實際影片時數、上架時間、單元安排、題型選擇與提供方式，均以 Becker Taiwan（捷進）中文雲端教室公告及實際上架內容為準。

9. 含中文課程方案之中文課程使用規範
9.1. 本方案為含中文課程之方案。學員可以其所持中文課程觀看額度，選擇觀看本方案開放之英文 CMA 考試中文雲端課程、英文 CMA CBQ 解題影片及／或中文 CMA 考試中文雲端課程，依逐次使用點數扣除額度，使用後不得要求變更、轉讓、返還點數或重複行使權益。
9.2. 本方案學員得使用之中文課程觀看額度為 200 小時。此觀看額度可自由分配於英文 CMA 考試中文雲端課程、英文 CMA CBQ 解題影片、中文 CMA 考試中文雲端課程、重複觀看同一堂課，或集中使用於特定章節與單元。
9.3. 本方案不限制學員必須選擇單一路徑。學員可依自身備考規劃，將觀看額度全部用於英文 CMA 考試中文雲端課程及英文 CMA CBQ 解題影片、全部用於中文 CMA 考試中文雲端課程，或同時搭配使用兩種課程。
9.4. 學員使用中文課程觀看額度後，不得以改變備考語言、改變應考科目、改變考試時程、未能參加考試、未通過考試、IMA 考場安排變更、課程尚未完整使用或個人時間安排不便為由，要求退還已使用額度、補發額度、折現、退費、轉讓或延長使用效期。
9.5. 中文課程觀看額度限學員本人於本方案效期內使用，不得轉讓、出售、出借、贈與、共享或提供予第三人使用。
9.6. 本方案提供之 200 小時觀看額度已包含補課與複習彈性。若學員於方案效期內用罄觀看額度，可另行加購觀看時數。加購價格、申請方式、可使用期限與相關限制，依 Becker Taiwan（捷進）當時公告或規定為準。

10. 雲端課程點數與加購方式
10.1. 學員使用中文雲端課程時，每次申請並使用觀看點數為計算憑證，由學員所持中文課程觀看額度中扣除。每一點數代表一小時上課時數。
10.2. 中文雲端課程每堂課長度原則上約為一小時。學員每次點開一堂課，即扣一個觀看點數，等同扣除該堂一小時完整影片時數。
10.3. 學員確認扣點並開始觀看後，可於「該堂課影片總時長 + 額外二小時緩衝期」內觀看該堂課程影片。期間可暫停、倒帶、調整播放速度，且不會重複扣點。
10.4. 舉例而言，一堂一小時的課程影片，學員確認扣點後，可在一小時影片長度加上二小時緩衝期、合計三小時內觀看該堂課程。
10.5. 額外二小時緩衝期係為提供學習彈性，使學員可暫停做筆記、短暫休息或臨時離席後再回到課程繼續學習。緩衝期屆滿後，若學員欲再次觀看該堂課程，須重新申請並扣除觀看點數。
10.6. 課程影片可支援 0.5x、1x、1.25x、1.5x、1.75x、2x 倍速播放。學員可依自身學習需求，於系統功能允許範圍內調整播放速度或跳轉至欲觀看段落。
10.7. 若因學員個人設備、網路、瀏覽器、系統、登入狀態、未正確操作、逾時、未於有效觀看期間內完成觀看，或其他非可歸責於 Becker Taiwan（捷進）之事由，導致該次觀看期間屆滿或點數已扣除，學員不得要求返還點數。但如學員可提出具體系統異常資訊，Becker Taiwan（捷進）得依實際情形協助查詢與處理。
10.8. 學員購買本方案所含中文課程觀看額度用罄時，於本方案有效效期內，得以單堂為單位加購使用額度。加購單堂時數長度與金額依 Becker Taiwan（捷進）當時公告或規定為準；若無另行公告，Becker Taiwan（捷進）得保留是否提供加購、加購價格、加購期限及使用限制之決定權。

11. 中文 CMA 與英文 CMA 考試關係
11.1. 遵循美國管理會計師協會（IMA）公開說明，中文 CMA 與英文 CMA 的考試內容範圍相同。考生無論通過中文 CMA 或英文 CMA，通過考試後皆可進一步申請美國管理會計師 CMA 證照。
11.2. 遵循美國管理會計師協會（IMA）公開說明，CMA 證照本身為同一張國際證照，不會註明考生是以中文或英文通過考試。證照價值、國際認可度與專業資格效力一致。
11.3. 學員可依自身語言能力、職涯規劃、考試形式偏好、考場安排與備考進度，選擇中文 CMA 或英文 CMA 的應考路徑。
11.4. Becker Taiwan（捷進）提供本方案之目的在於協助學員準備 CMA 考試，惟不保證學員完成本方案後必定通過中文 CMA 或英文 CMA 考試，亦不保證學員必定符合 CMA 證照申請資格。

12. 中文 CMA 考試用語、考試形式與紙筆考試說明
12.1. 中文 CMA 考試過往長年主要針對中國考生提供，並於中國境內舉行。考試題目、專業術語、用字遣詞與閱卷制度，皆沿用中文 CMA 考試既有系統與中國財會專業用語習慣。
12.2. 對台灣考生而言，雖然中文 CMA 是中文考試，但考題中使用的專業術語、財會用語與題目表述方式，可能與台灣考生平常熟悉的繁體中文財會用語不同。學員應自行留意相關 terminology 差異，並善用本方案提供之中文 CMA 考試中文雲端課程與 CMA 考試中英繁簡用詞對照表進行準備。
12.3. 中文 CMA 考試為紙筆考試。英文 CMA 考試為電腦考試，不提供紙筆考試。
12.4. Becker CMA Exam Review 為線上軟體題庫。準備中文 CMA 的學員在使用 Becker 題庫練習時，應自行納入紙筆考試情境，例如將 Becker 題目列印後，練習紙筆作答、時間分配、答案組織與手寫表達，以銜接中文 CMA 紙筆考試形式。
12.5. 中文 CMA 考試之實際題本語言、題本形式、作答規定、閱卷安排與考試當次相關規範，均以 IMA 官方最新公告與考試當次規定為準。

13. 中文 CMA 台灣考場與 IMA 官方規定
13.1. Becker Taiwan（捷進）近年積極向 IMA 爭取，協助台灣考生取得不必出國、即有機會於台灣應考中文 CMA 的機會。
13.2. 依 2026 年 7 月與 IMA 溝通之資訊，若同一 testing window 台灣考生合計達 10 人報考中文 CMA，不限 Becker Taiwan 學員、不限同一科目，Part 1 與 Part 2 可合併計算，即有機會安排台灣中文 CMA 考試。
13.3. 實際考試日期、考場開放、報名規則、人數門檻認定、考試語言、題本形式、作答規定、閱卷安排及其他相關應考安排，皆須以 IMA 或其指定機構之最新公告與最終規定為準。
13.4. Becker Taiwan（捷進）為 CMA 教材與課程服務提供者，並非 CMA 考試主辦單位、考場安排單位、報名審查單位或證照審查單位。實際考場開放、考試報名、考試安排、應考規範、閱卷與證照核發，均由 IMA 或其指定機構負責處理、決定與公告。
13.5. 若特定 testing window 未達中文 CMA 台灣考場安排門檻，或 IMA 未於該 testing window 開放台灣中文 CMA 考場，考生仍可依自身需求選擇前往中國境內應考中文 CMA 考試，或改於台灣考場應考英文 CMA 考試。相關報名資格、考試費用、考場安排、報名期限、考試規則及其他應考事項，均由 IMA 或其指定機構依官方規定辦理。
13.6. 學員不得因 IMA 考場安排、人數門檻認定、考試日期、報名規則、考試語言、題本形式、閱卷安排、考場地點、官方政策或其他非 Becker Taiwan（捷進）可控制事項之變動，要求 Becker Taiwan（捷進）退費、賠償、展延、補償或承擔其他責任。

14. CMA 考試中英繁簡用詞對照表與中文 CMA 題型參考資料
14.1. 本方案包含 CMA 考試中英繁簡用詞對照表，供學員本人於本方案效期內備考使用。該用詞對照表之目的在於協助學員銜接 Becker 英文教材、台灣繁體中文財會用語與中文 CMA 考試常見用語，降低因用詞差異造成的理解落差。
14.2. 本方案包含中文 CMA 考試歷年題型參考資料／Sample Test，供購買本方案之學員熟悉中文 CMA 考試的題型、用詞、表述方式與作答方向。
14.3. 中文 CMA 考試歷年題型參考資料／Sample Test 由 IMA China 版權所有，經 Becker Taiwan（捷進）提供予本方案學員本人備考使用。學員僅得於合法備考目的範圍內自行使用，不得作任何非本方案備考目的之使用。
14.4. 學員不得將 CMA 考試中英繁簡用詞對照表、中文 CMA 考試歷年題型參考資料／Sample Test 或其他本方案所含資料進行外流、轉載、複製、公開分享、轉售、上傳至公開平台、提供予第三人、作為商業用途、作為教學用途，或以任何方式侵害 Becker Taiwan（捷進）、Becker Professional Education、IMA、IMA China 或其他權利人之智慧財產權。
14.5. Becker Taiwan（捷進）得視實際需要，於檔案中加入版權聲明、學員識別資訊、浮水印或其他合理保護措施。學員不得移除、遮蔽、修改或規避相關權利標示或保護措施。
14.6. 若學員違反本條規定，Becker Taiwan（捷進）得立即暫停或終止其本方案使用權限，並得依法請求損害賠償及採取其他法律行動。學員不得要求退費、補償或恢復使用權限。

15. 諮詢服務、預約與服務調整
15.1. Becker Taiwan（捷進）保有各項線上／電話／通訊軟體諮詢服務、雲端流量分配、服務時間安排分配之決定權。
15.2. 學員欲使用上開諮詢服務或加值服務，均須提前來電、來信或來訊預約，以確認服務團隊、辦公室空間之服務狀態與起迄時間。
15.3. 配合中華民國各級政府單位規定，遇天災、疫情、緊急事件或其他不可抗力因素，致 Becker Taiwan（捷進）提供之線上／電話／通訊軟體諮詢服務受到影響時，Becker Taiwan（捷進）將依實際情形調整服務提供方式、服務時間或暫停受影響之服務。
15.4. 以上中文課程項目、CBQ 解題影片、加值服務與相關內容，Becker Taiwan（捷進）保留變更、終止、修改及解釋之權利。
15.5. Becker Taiwan（捷進）提供之諮詢服務，以本方案使用、課程安排、教材使用、一般備考流程與相關行政協助為範圍，不包含保證個人考試通過、保證官方報考資格、保證證照申請成功、代辦 IMA 官方審查、代為完成考試報名、代為預約考場或提供法律、稅務、移民、職涯錄取保證等服務。

16. 報考資格、考試報名與官方審查
16.1. 購買者之報考資格、考試資格、證照申請資格、學歷與工作經驗認定，均應以 IMA 或考試指定之認證機構、報名審查官方機構、證照審查官方機構出具之審查結果為準。
16.2. Becker Taiwan（捷進）可依本方案服務範圍提供一般性資訊與行政協助，但不代表 IMA 或任何官方機構作成資格認定、報名核准、考場保證、考試結果判定或證照核發決定。
16.3. 學員應自行確認並遵守 IMA 官方報名期限、考試政策、考場規則、證照申請規定、會員費與考試費繳納規定。因學員未即時報名、未完成繳費、未符合資格、未遵守官方規定、未通過官方審查或其他非可歸責於 Becker Taiwan（捷進）之事由，導致無法考試、無法取得成績、無法申請證照或權益受影響者，學員應自負其責。

17. 個人資料保護與隱私權聲明
17.1. Becker Taiwan（捷進）基於本訂購單履約之目的，蒐集、處理並利用您的個人資料。本公司將依個人資料保護法第 8 條第 1 項之要求，向您告知以下事項。
17.2. 蒐集目的：依照 101 年 10 月 1 日修正之個人資料保護法之特定目的及個人資料之類別，040 行銷、069 契約、類似契約或其他法律關係事務、090 消費者客戶管理與服務、157 調查、統計與研究分析、181 其他經營合於營業登記項目或組織章程所定之業務、182 其他諮詢與顧問服務。
17.3. 個人資料類別：C001 電子郵件、中文姓名、英文拼音全名、電話號碼。C002 金融機構帳戶號碼與姓名。C003 身分證字號。C036 是否曾訂購本公司產品、得知本公司之管道。C038 在職身分。C051 所屬或畢業學校與科系。及為履行本方案、開通 Becker 原廠帳號、提供中文雲端課程、提供題型參考資料、提供客服與學員管理所必要之其他資料。
17.4. 個人資料利用之期間、地區：本公司會於契約履行、學員服務、帳務處理、法令保存期間及爭議處理所必要期間內利用您的個人資料；利用地區包含中華民國境內及 Becker 原廠帳號開通、服務提供所必要之境外地區。
17.5. 個人資料利用對象及方法：本公司將會依照您所填寫之訂購資料，確認您已完成訂購，並替您註冊帳號、寄送商品、提供學員管理、行銷活動等服務。並將分析您提供之類別 C036、C038、C051 等資訊，以增進本公司之服務。除為履行本契約、開通 Becker 原廠帳號、提供中文雲端課程、寄送商品、金流／物流／系統服務所必要，或依法令要求外，在未經您的同意下，我們不會任意將您的個人資料提供給第三人或作不當利用。
17.6. 如您所提供之個人資料不正確或不完整，可能將無法完整履行訂購單內容。
17.7. 您得行使個資法第 3 條所賦予之相關權利，如您欲行使該權利請來信 service@beckertw.com。

18. 付費購買與匯款資訊
18.1 在台購買
收款人戶名
捷進顧問有限公司
受款銀行
華南商業銀行信維分行（代碼：008）
收款人帳號
149-10-010062-0
匯款金額
以新台幣付費，依各方案價格計算；若需快遞書籍，請加上運費。


台灣境內快遞計費方式：便利袋快遞費每箱新台幣 100 元。因快遞公司重量限制，寄送 1–2 本為一箱，寄送 3–4 本須為兩箱。
18.2 海外購買
Recipient Name
Direct Line Consulting Co.
Account Number
149-10-010062-0
Bank
Hua Nan Commercial Bank Ltd.
Branch
Hsin-Wei Branch
SWIFT Code（Bank ID）
HNBKTWTP149
Bank Address
2F, No. 6, Xinyi Rd. Sec. 4, Da'an Dist., 106 Taipei City, Taiwan


快遞計費方式：由美國 Becker 直接發貨，單次寄送郵資為新台幣 1,200 元。
18.4. 匯款金額：以新台幣付費，依本方案價格計算；若需快遞書籍或加購其他服務，請加上相關費用，並請採全額到匯。相關中轉行手續費計算方式請向您的支付銀行確認；若無法估算，請直接另附新台幣 200 元之中轉行手續費。
18.5. 海外快遞計費方式：由美國 Becker 或相關供應方直接發貨者，單次寄送郵資依 Becker Taiwan（捷進）當時公告或實際費用計算。
18.6. Becker Taiwan（捷進）保留依匯率、原廠價格、國際運費、金流成本、稅費、供應條件或其他合理商業因素調整價格、加購費用、快遞費用或相關收費之權利。已完成訂購並付款者，依其購買當時方案價格辦理，除另有約定外，不因日後價格調整而補收或退還差額。

19. 終止契約
19.1. 學員如有違反強制禁止規定或公序良俗之行為，或違反本契約經限期改正仍未改正者，Becker Taiwan（捷進）得終止本契約，學員不得異議。
19.2. 如學員自行或因可歸責於己之事由終止契約者，除可歸責於 Becker Taiwan（捷進）或依法不得排除之情形外，教材一經領取、帳號開通、登入使用、中文雲端課程點數提供、課程內容提供或本方案所含資料檔案提供後，學員不得任意要求退費、暫停效期、展延效期或其他補償。
19.3. 學員如有下列情形之一者，Becker Taiwan（捷進）得立即暫停或終止其軟體帳號、中文雲端課程、資料下載權限及本方案相關服務，學員不得要求退費、賠償或補償：
帳號轉讓、出售、出租、出借、共享或提供第三人使用。
多人共用同一帳號。
側錄、錄音、錄影、截圖、翻拍、下載、重製或散布課程內容。
外流、轉售、公開分享、複製或提供本方案資料予第三人。
侵害 Becker Taiwan（捷進）、Becker Professional Education、IMA、IMA China 或其他權利人之智慧財產權。
以不正當方式干擾、破解、規避、擷取、反向工程或使用系統。
提供不實資料或冒用他人身分購買、登入或使用本方案。
其他重大違反本契約或法令之行為。
19.4. 本契約終止後，學員應立即停止使用本方案所含軟體、課程、資料、講義、題型參考資料、用詞對照表及其他內容。契約終止不影響 Becker Taiwan（捷進）依本契約或法律得主張之權利。

20. 智慧財產權與保密義務
20.1. 本方案所含 Becker CMA Exam Review 軟體、教材、題庫、影片、模擬考、講義、中文雲端課程、CMA 考試中英繁簡用詞對照表、中文 CMA 考試歷年題型參考資料／Sample Test、課程資料、圖表、文字、影音內容與其他相關資料，均受著作權法、商標法、營業秘密法及其他相關法令保護。
20.2. 學員僅取得依本契約於方案效期內為個人備考目的使用相關內容之有限、非專屬、不可轉讓、不可再授權之使用權。學員並未取得任何所有權、著作權、商標權、資料庫權、營業秘密或其他智慧財產權。
20.3. 未經 Becker Taiwan（捷進）、Becker Professional Education、IMA、IMA China 或相關權利人事前書面同意，學員不得將本方案內容作為教學、出版、商業服務、二次販售、公開分享、內部訓練、顧問服務或其他非個人備考用途。
20.4. 學員違反本條規定者，除應自行負擔相關民、刑事及行政責任外，並應賠償 Becker Taiwan（捷進）因此所受之一切損害、費用及支出，包括但不限於律師費、訴訟費、調查費、權利人求償金額及商譽損害。

21. 其他重要聲明
21.1. Becker Taiwan（捷進）提供本方案之目的在於提供 CMA 備考教材、課程與相關學習資源，惟學習成效與考試結果仍受學員個人背景、投入時間、學習方式、考試狀態、官方政策及其他因素影響。Becker Taiwan（捷進）不保證學員必定通過考試或取得證照。
21.2. 本方案所提及之 IMA、CMA 考試、中文 CMA 考試、英文 CMA 考試、考場安排、報名規則、考試形式、閱卷安排、證照申請及其他官方事項，均應以 IMA 官方最新公告與最終規定為準。若官方資訊與 Becker Taiwan（捷進）提供之一般性說明有不一致之處，應以官方公告為準。
21.3. Becker Taiwan（捷進）得因原廠政策、官方考試規則、課程更新、題型改制、系統調整、法令要求、服務營運或其他合理事由，調整本方案之服務細節、課程提供方式、資料提供方式、客服流程或相關規定。若涉及學員重大權益，Becker Taiwan（捷進）將於合理範圍內通知學員。
21.4. 本契約未盡事宜，依中華民國相關法令及誠信原則處理。
21.5. 因本契約所生或與本契約有關之一切爭議，雙方應先本於誠信原則協商解決；如協商不成，雙方同意以台灣台北地方法院為第一審管轄法院，惟不得排除消費者保護法或其他法律所定之法定管轄。

22. 購買者確認事項
購買者於訂購流程中勾選同意並完成購買時，即確認：
22.1. 已完整審閱本購買須知與相關規定，審閱期已達五日。
22.2. 已理解本方案為 CMA 備考教材與課程方案，並非考試報名、考場保證、證照申請保證或考試通過保證。
22.3. 已知悉 Becker CMA Exam Review 為全英文介面、英文教材與英文題庫。
22.4. 已知悉本方案包含英文 CMA 考試中文雲端課程、英文 CMA CBQ 解題影片與中文 CMA 考試中文雲端課程，並可於方案效期內依 200 小時觀看額度規定使用。
22.5. 已知悉中文 CMA 考試中文雲端課程及英文 CMA CBQ 解題影片將依 Becker Taiwan 中文雲端教室公告與最新課表陸續上架，實際上架時間、單元安排、影片時數與提供方式以公告及實際上架內容為準。
22.6. 已知悉中文 CMA 與英文 CMA 考試內容範圍相同，通過後可申請同一張 CMA 證照；CMA 證照不會註明考試語言。
22.7. 已知悉中文 CMA 考試為紙筆考試，英文 CMA 考試為電腦考試；並已知悉英文 CMA 考試將於 2026 年 11 月 1 日起，在台灣考場由 essay questions 改為 Case-Based Questions（CBQs）。準備中文 CMA 時，因 Becker CMA Exam Review 為線上軟體題庫，應自行納入紙筆作答情境。
22.8. 已知悉中文 CMA 台灣考場安排、人數門檻、考試日期、報名規則、考試語言、題本形式、作答規定與閱卷安排，皆以 IMA 官方最新公告與最終規定為準，Becker Taiwan（捷進）不保證特定 testing window 必定開放台灣中文 CMA 考場。
22.9. 已知悉本方案所含 CMA 考試中英繁簡用詞對照表與中文 CMA 考試歷年題型參考資料／Sample Test 僅限本人備考使用，不得外流、轉載、複製、公開分享、轉售或提供予第三人。
22.10. 已知悉一經帳號開通、登入、教材領取、課程內容提供、中文雲端課程點數提供或本方案所含資料檔案提供，即排除消保法第 19 條七日解除權之適用，除可歸責於 Becker Taiwan（捷進）或依法不得排除之情形外，不得任意要求退費、暫停效期、展延效期或其他補償。`;

    const renderLine = (line, index) => {
        const text = line.trim();

        if (!text) {
            return <div key={index} className="mb-3"></div>;
        }

        if (
            index === 0 ||
            text === "購買須知與相關規定（請務必詳閱）"
        ) {
            return (
                <div key={index} className="text-center mb-2">
                    {text}
                </div>
            );
        }

        if (/^\d+\.\s/.test(text)) {
            return (
                <div key={index}>
                    <div className="br mb-5 mt-3"></div>
                    <div className="h4">{text}</div>
                </div>
            );
        }

        if (/^\d+\.\d+\./.test(text)) {
            return <div key={index} className="h5 mt-4">{text}</div>;
        }

        if (
            text === "收款人戶名" ||
            text === "受款銀行" ||
            text === "收款人帳號" ||
            text === "匯款金額" ||
            text === "Recipient Name" ||
            text === "Account Number" ||
            text === "Bank" ||
            text === "Branch" ||
            text.startsWith("SWIFT Code") ||
            text === "Bank Address"
        ) {
            return <div key={index} className="fw-bold mt-3 mb-1">{text}</div>;
        }

        return <p key={index} className="mb-2">{text}</p>;
    };

    return (
        <div className="container mb100 mt100">
            <div className="beckertitlename mb100 mt100">
                Becker CMA 中英文雙軌備考方案
            </div>

            <div className="card w-75 p-5 m-auto">
                <h5 className="card-title text-black text-center">
                    Becker CMA 中英文雙軌備考方案<br />
                    購買須知與相關規定（請務必詳閱）
                </h5>

                <div className="br mb-5 mt-3"></div>

                <div className="card-body">
                    <div className="card-text m-auto">
                        {contractText.split("\n").map(renderLine)}
                    </div>

                    <div className="text-center">
                        <label>
                            <input
                                className="m-2"
                                type="checkbox"
                                value="read"
                                checked={isChecked}
                                onChange={handleCheckboxChange}
                                required
                            />
                            <span>我已詳閱並且了解</span>
                        </label>

                        <div
                            className="btn btn-primary m-3"
                            onClick={handleNextButtonClick}
                        >
                            下一步
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}